import { useMemo } from 'react';
import { Form, Row, Col, FloatingLabel, Container } from 'react-bootstrap';

export interface AttackBonusDetails {
  attackBonus: number;
  hitBonus: number;
  woundBonus: number;
  rendBonus: number;
  damageBonus: number;
  attackBonusEC: boolean;
  hitBonusEC: boolean;
  woundBonusEC: boolean;
  rendBonusEC: boolean;
  damageBonusEC: boolean;
}

export const defaultAttackBonusDetails = {
  attackBonus: 0,
  hitBonus: 0,
  woundBonus: 0,
  rendBonus: 0,
  damageBonus: 0,
  attackBonusEC: false,
  hitBonusEC: false,
  woundBonusEC: false,
  rendBonusEC: false,
  damageBonusEC: false,
};

interface AttackBonusesProps {
  attackBonusDetails: AttackBonusDetails;
  onAttackBonusChange: (details: AttackBonusDetails) => void;
}

const bonuses = [-2, -1, 0, 1, 2];
const restrictedBonuses = [-1, 0, 1];

function AttackBonuses({
  attackBonusDetails,
  onAttackBonusChange
}: AttackBonusesProps) {
  const attackBonusMenuItems = useMemo(() => bonuses.map((t, i) => (
    <option key={`attack${i}`} value={t}>{t}</option>
  )), []);

  const hitBonusMenuItems = useMemo(() => restrictedBonuses.map((t, i) => (
    <option key={`hit${i}`} value={t}>{t}</option>
  )), []);

  const woundBonusMenuItems = useMemo(() => restrictedBonuses.map((t, i) => (
    <option key={`wound${i}`} value={t}>{t}</option>
  )), []);

  const rendBonusMenuItems = useMemo(() => bonuses.map((t, i) => (
    <option key={`rend${i}`} value={t}>{t}</option>
  )), []);

  const damageBonusMenuItems = useMemo(() => bonuses.map((t, i) => (
    <option key={`damage${i}`} value={t}>{t}</option>
  )), []);

  return (
    <div>
      <Container>
        <Row className="mb-3">
          <Col>
            <FloatingLabel label="Attacks">
              <Form.Select 
                value={attackBonusDetails.attackBonus} 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, attackBonus: Number(event.target.value) })}
              >
                {attackBonusMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
    
          <Col>
            {
              attackBonusDetails.attackBonus > 0 && 
              <Form.Check 
                checked={attackBonusDetails.attackBonusEC}
                label="Effects Companion" 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, attackBonusEC: Boolean(event.target.value) })} 
              />
            }
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <FloatingLabel label="Hit">
              <Form.Select 
                value={attackBonusDetails.hitBonus} 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, hitBonus: Number(event.target.value) })}
              >
                {hitBonusMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
    
          <Col>
            {
              attackBonusDetails.hitBonus > 0 && 
              <Form.Check 
                checked={attackBonusDetails.hitBonusEC}
                label="Effects Companion" 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, hitBonusEC: Boolean(event.target.value) })} 
              />
            }
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <FloatingLabel label="Wound">
              <Form.Select 
                value={attackBonusDetails.woundBonus} 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, woundBonus: Number(event.target.value) })}
              >
                {woundBonusMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
    
          <Col>
            {
              attackBonusDetails.woundBonus > 0 && 
              <Form.Check 
                checked={attackBonusDetails.woundBonusEC}
                label="Effects Companion" 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, woundBonusEC: Boolean(event.target.value) })} 
              />
            }
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <FloatingLabel label="Rend">
              <Form.Select 
                value={attackBonusDetails.rendBonus} 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, rendBonus: Number(event.target.value) })}
              >
                {rendBonusMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
    
          <Col>
            {
              attackBonusDetails.rendBonus > 0 && 
              <Form.Check 
                checked={attackBonusDetails.rendBonusEC}
                label="Effects Companion" 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, rendBonusEC: Boolean(event.target.value) })} 
              />
            }
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <FloatingLabel label="Damage">
              <Form.Select 
                value={attackBonusDetails.damageBonus} 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, damageBonus: Number(event.target.value) })}
              >
                {damageBonusMenuItems}
              </Form.Select>
            </FloatingLabel>
          </Col>
    
          <Col>
            {
              attackBonusDetails.damageBonus > 0 && 
              <Form.Check 
                checked={attackBonusDetails.damageBonusEC}
                label="Effects Companion" 
                onChange={(event) => onAttackBonusChange({ ...attackBonusDetails, damageBonusEC: Boolean(event.target.value) })} 
              />
            }
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AttackBonuses;